export type PdfJsModule = typeof import('pdfjs-dist');
export type PdfViewerModule = typeof import('pdfjs-dist/web/pdf_viewer.mjs');

let modulesPromise:
  | Promise<{
      pdfjs: PdfJsModule;
      viewer: PdfViewerModule;
    }>
  | undefined;

/**
 * Loads the pdf.js styles and ESM-only runtime on demand. The viewer module
 * expects the core module on `globalThis`, so it must be loaded and assigned
 * first.
 */
export function loadPdfJsModules() {
  modulesPromise ??= Promise.all([
    import('pdfjs-dist/web/pdf_viewer.css'),
    import('./pdfViewerRuntime.module.scss'),
    import('pdfjs-dist'),
  ]).then(async (modules) => {
    const pdfjs = modules[2];
    Object.assign(globalThis, { pdfjsLib: pdfjs });
    const viewer = await import('pdfjs-dist/web/pdf_viewer.mjs');
    return { pdfjs, viewer };
  });
  return modulesPromise;
}
